import { render, staticRenderFns } from "./PorletFormularioHorizontal.vue?vue&type=template&id=1bca38b9"
import script from "./PorletFormularioHorizontal.vue?vue&type=script&lang=js"
export * from "./PorletFormularioHorizontal.vue?vue&type=script&lang=js"
import style0 from "./PorletFormularioHorizontal.vue?vue&type=style&index=0&id=1bca38b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports